var _rect, _line, _rect2, _rect3, _rect4, _circle, _circle2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _line2, _circle3, _path2, _path3, _path4, _circle4, _circle5, _path5, _path6, _circle6, _circle7, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 150,
    width: 185,
    height: 12,
    rx: 4,
    fill: "rgba(255,255,255,0.12)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 150,
    x2: 203,
    y2: 150,
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 170,
    height: 125,
    rx: 7,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.75)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 33,
    width: 154,
    height: 110,
    rx: 4,
    fill: "rgba(255,255,255,0.06)",
    stroke: "rgba(255,255,255,0.22)",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 33,
    width: 154,
    height: 14,
    rx: 4,
    fill: "rgba(255,255,255,0.16)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 40,
    r: 2.5,
    fill: "rgba(255,255,255,0.45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 2.5,
    fill: "rgba(255,255,255,0.45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 36,
    width: 60,
    height: 7,
    rx: 3.5,
    fill: "rgba(255,255,255,0.25)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 53,
    width: 66,
    height: 22,
    rx: 3,
    fill: "rgba(255,255,255,0.13)",
    stroke: "rgba(255,255,255,0.45)",
    strokeWidth: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 58,
    width: 40,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.65)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 65,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "rgba(255,255,255,0.35)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 80,
    width: 66,
    height: 22,
    rx: 3,
    fill: "rgba(255,255,255,0.13)",
    stroke: "rgba(255,255,255,0.45)",
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 85,
    width: 34,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.65)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 92,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "rgba(255,255,255,0.35)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 55 L115 82 L122 74 L127 88 L131 86 L126 72 L135 72 Z",
    fill: "rgba(255,255,255,0.85)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 88,
    x2: 218,
    y2: 88,
    stroke: "rgba(255,255,255,0.35)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 88,
    r: 4,
    fill: "rgba(255,255,255,0.85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 228,71 A 20,20 0 0,1 228,105",
    stroke: "rgba(255,255,255,0.75)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 236,55 A 36,36 0 0,1 236,121",
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 244,40 A 52,52 0 0,1 244,136",
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 88,
    r: 20,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 82,
    r: 7,
    fill: "rgba(255,255,255,0.65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276 103 Q276 94 292 94 Q308 94 308 103",
    fill: "rgba(255,255,255,0.4)",
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283 80 Q283 71 292 71 Q301 71 301 80",
    stroke: "rgba(255,255,255,0.8)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 81,
    r: 2.5,
    fill: "rgba(255,255,255,0.8)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 81,
    r: 2.5,
    fill: "rgba(255,255,255,0.8)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283 83 L279 86 L281 89",
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportHero);
export default __webpack_public_path__ + "static/media/support_hero.2cf22b770109bd07dff6db1626539603.svg";
export { ForwardRef as ReactComponent };